import { NotaModel } from './../types';
import { ConfigType } from './..';
import { capitalize } from './stringFunctions';
import { isMobile } from './isMobile';

enum ImageSize {
  UHD = 4096,
  FH = 1920,
  HP = 1600,
  WD = 1366,
  D = 1024,
  TB = 768,
  M = 640,
  R = 300,
}


export class Urls {

  private static config: ConfigType | undefined;

  static setConfig = (config?: ConfigType): void => {
    Urls.config = config;
  };

  static getCDN = (key: string | null | undefined, size = ''): string => {
    return Urls.config?.REACT_CDN_BASE_URL + (key ?? '') + '/' + size;
  };

  static getApi = (): string | undefined => {
    return Urls.config?.REACT_API_BASE_URL;
  };

  static getNavBar = (): string | undefined => {
    return Urls.config?.NAVBAR_URL;
  };

  static getFooter = (): string | undefined => {
    return Urls.config?.FOOTER_URL;
  };

  static getYoutubeEmbedUrl(key: string, autoplay = 1): string {
    return `https://www.youtube.com/embed/${key}?autoplay=${autoplay}`;
  }

  static getYoutubeDefaultt(url: string): string {
    return 'https://img.youtube.com/vi/' + url + '/hqdefault.jpg';
  }
  static getCapturaDefaultImagen(): string {
    return this.getCDN('miniatura_default');
  }

  static getSrcSet(clave?: string | null, ratio = 1): string {
    ratio = !isMobile() ? ratio : 1;

    /* if (clave) {

      const maxSize = this.getMaxImageSize(ratio);
      return Object.keys(ImageSize)
        .filter(x => !isNaN(+x))
        .filter(x => +x <= maxSize)
        .map(x => ({ key: x, res: (+x / ratio) | 0 }))
        .map(({ key, res }) => `${Urls.getCDN(clave, ImageSize[key])} ${res < this.defaultMaxSize() ? res : this.defaultMaxSize()}w`)
        .join(', ');
    }
 */
    return Urls.getCDN(clave);
  }

  private static defaultMaxSize(): ImageSize {
    return ImageSize.UHD;
  }

  private static getMaxImageSize(ratio : any): number {

    const maxSize = (ImageSize.UHD * ratio) | 0;

    const [first] = Object.keys(ImageSize)
      .filter(x => +x > maxSize)
      .sort((x, y) => (+x) - (+y))
    return first ? +first : this.defaultMaxSize();

  }

  public static getUrlNota(nota: NotaModel): string {

    const url = nota.tipo?.urlKey ?? 'Archivo';

    return `/${capitalize(url)}/${nota.tituloSlugged}-${nota?.slugId}`
  }


  public static getUrlListado(nota: NotaModel): string {


    return `/${capitalize(nota.tipo?.urlKey ?? '')}`
  }

}
